import React, { useEffect } from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import Table from "components/Common/dataTable";
import CustomButton from "components/Common/ui/CustomButton";
import useClassManagement from "../hooks/useClassManagement";
import UserProfileHeader from "components/Common/ui/UserProfileHeader";

export interface ClassStudentRow {
  id: string;
  massarCode: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    gender?: string;
    photo?: string;
    status?: string;
    email?: string;
  };
}

export interface TabStudentClassProps {
  loading?: boolean;
  canUpdate: boolean;
  onOpenAssign(): void;
  classId: string;
  refreshTrigger?: number; // Add this prop
}

const TabStudentClass: React.FC<TabStudentClassProps> = ({
  loading = false,
  canUpdate,
  onOpenAssign,
  classId,
  refreshTrigger = 0, 
}) => {
  const { t } = useTranslation();
  const { handleGetAssignedStudents, assignedStudents } = useClassManagement(); // Remove handleAssignStudentsSave
  
  useEffect(() => {
    handleGetAssignedStudents(classId);
  }, [classId, refreshTrigger]); 

  const columns = [
    {
      title: t("student_name"),
      render: (_: any, r: ClassStudentRow) => <UserProfileHeader firstName={r?.user?.firstName} lastName={r?.user?.lastName} photo={r?.user?.photo} />,
    },
    {
      title: t("email"),
      dataIndex: ["user", "email"],
      render: (_: any, r: ClassStudentRow) => r?.user?.email || "—",
    },
    { title: t("massarCode"), dataIndex: ["massarCode"], render: (_: any, r: ClassStudentRow) => r?.massarCode || "—" },
    { title: t("gender"), dataIndex: ["user", "gender"], render: (_: any, r: ClassStudentRow) => (r?.user?.gender ? t(r.user.gender) : "—") },
  ];

  return (
    <>
      <div className="d-flex justify-content-end mb-2">
        {canUpdate && (
          <CustomButton onClick={onOpenAssign} variant="primary" size="md">
            <i className="ti ti-user-plus me-2" /> {t("assign_students")}
          </CustomButton>
        )}
      </div>
      <Table dataSource={assignedStudents} columns={columns as any} pagination={true} loading={loading} />
    </>
  );
};

export default TabStudentClass;